import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from '@mui/material/Grid';
import Link from "@mui/material/Link";

import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import SmartDisplayOutlinedIcon from '@mui/icons-material/SmartDisplayOutlined';
import ImportantDevicesOutlinedIcon from '@mui/icons-material/ImportantDevicesOutlined';

import Modal from "../../components/Modal";
import Button from "@mui/material/Button";
import ClearIcon from "@mui/icons-material/Clear";
import saludoCumple from "../../assets/images/cumple.jpg";

import Page from "../../layout/Page";
import api from "../../service/api";

const BoxLink = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2, 4),
  border: 1,
  borderRadius: 3,
  color: "#fff",
  display: "flex",
  flexDirection: "row",
  //justifyContent: "space-around"
}));

const Inicio = () => {

  const [showSaludo, setShowSaludo] = useState(false);
  const cerrarSaludo = () => setShowSaludo(false);
  const [nombreSaludo, setNombreSaludo] = useState("");

  const saludoAlumno = () => {
    api
      .saludo()
      .then((res) => {
        if (res.data[0].cumple === 'S') {
          setNombreSaludo(res.data[0].nombre);
          setShowSaludo(true);
        } else {
          setNombreSaludo("");
          setShowSaludo(false);
        }

      })
      .catch((e) => {
        console.log("Error buscar datos de cumpleaños");
      });
  };

  useEffect(() => {
    saludoAlumno();
  }, []);

  const breadcrumbs = [{ nombre: "Inicio", ruta: "/" }];

  return (
    <Page breadcrumbs={breadcrumbs}>
      <Box sx={{ backgroundColor: "#D8DBE0", pl: 2, pr: 2, pt: 4, pb: 4 }} >
        <Typography variant="titulo" paragraph>
          <b>Bienvenida/o:</b>
        </Typography>
        <Box pl={2}>
          <Typography variant="cuerpo" paragraph>
            Desarrollamos esta aplicación para que puedas gestionar tus datos personales, las inscripciones a los cursos, descargar los certificados de cursos aprobados.
          </Typography>         
        </Box>
      </Box>
      <br></br>
      <Grid container spacing={2}>
        <Grid item md={4} xs={12}>
          <BoxLink sx={{ backgroundColor: "#799F4F" }}>
            <Box SX={{ flexGrow: 0.2 }}>
              <LanguageOutlinedIcon sx={{ fontSize: 60 }} />
            </Box>
            <Box sx={{ flexGrow: 0.8, display: "flex", flexDirection: "column", justifyContent: 'space-evenly', alignItems: 'center' }}>
              <Link
                href="https://portal.entrerios.gov.ar/modernizacion/rrhh/capacitacion/"
                variant="aclaracion"
                sx={{ color: "#FFF" }}
                target="_blank"
              >
                <Typography variant="cuerpo" color="#fff"> Sitio web</Typography>
              </Link>
            </Box>
          </BoxLink>
        </Grid>
        <Grid item md={4} xs={12}>
          <BoxLink sx={{ backgroundColor: "#A8CF45" }}>
            <Box SX={{ flexGrow: 0.2 }}>
              <ImportantDevicesOutlinedIcon sx={{ fontSize: 60 }} />
            </Box>
            <Box sx={{ flexGrow: 0.8, display: "flex", flexDirection: "column", justifyContent: 'space-evenly', alignItems: 'center' }}>
              <Link
                href="https://campusvirtual.entrerios.gov.ar/"
                variant="aclaracion"
                sx={{ color: "#FFF" }}
                target="_blank"
              >
                <Typography variant="cuerpo" color="#fff"> Campus virtual</Typography>
              </Link>
            </Box>
          </BoxLink>
        </Grid>
        <Grid item md={4} xs={12}>
          <BoxLink sx={{ backgroundColor: "#2282E2" }}>
            <Box SX={{ flexGrow: 0.2 }}>
              <SmartDisplayOutlinedIcon sx={{ fontSize: 60 }} />
            </Box>
            <Box sx={{ flexGrow: 0.8, display: "flex", flexDirection: "column", justifyContent: 'space-evenly', alignItems: 'center' }}>
              <Link
                href="https://www.youtube.com/watch?v=tRY_vGOSjsM&ab_channel=Secretar%C3%ADadeModernizaci%C3%B3nEntreR%C3%ADos"
                variant="aclaracion"
                sx={{ color: "#FFF" }}
                target="_blank"
              >
                <Typography variant="cuerpo" color="#fff"> Video Tutorial</Typography>
              </Link>
            </Box>
          </BoxLink>
        </Grid>
      </Grid>

      <Modal open={showSaludo} handleClose={cerrarSaludo}>
        <Grid container justifyContent="space-between" spacing={0}>
          <Grid item xs={12} sm={12}>
            <Typography variant="extra" sx={{ color: '#1bc3e0' }} paragraph align="center">
              <b>{nombreSaludo}</b>
            </Typography>
          </Grid>
          <Grid item xs={12} sm={12} align="center">
            <img src={saludoCumple} alt="FELIZ CUMPLEAÑOS" align="center" width="90%" />
          </Grid>
        </Grid>
        <Grid container spacing={1}>
          <Grid
            item
            align="right"
            xs={12} sm={12}
          >
            <Box align="right">
              <Button
                variant="plata"
                onClick={() => cerrarSaludo()}
                endIcon={<ClearIcon />}
                sx={{ m: 1 }}
              >
                {"Cerrar"}
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Modal>

    </Page>
  );
};

export default Inicio;
